import { createFileRoute } from '@tanstack/react-router';

import { OvSedesPage } from '@/features/virtual-offices/pages/ov-sedes';

export const Route = createFileRoute('/_app/settings/ov-sedes')({
  component: OvSedesPage,
});
